import { SVGProps } from "react"

type Props = SVGProps<SVGSVGElement> & {
  size?: number
}

export const IconRawMaterial = ({ size = 24, ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 44 44"
    xmlSpace="preserve"
    width={size}
    height={size}
    {...props}
  >
    <style>
      {".raw_material1_svg__st0{fill:none;stroke:currentColor;stroke-width:2}"}
    </style>
    <g id="raw_material1_svg__Calque_2">
      <path
        className="raw_material1_svg__st0"
        d="M29.8 22c0 4.5-1 8.5-2.6 11.3-1.6 2.9-3.6 4.2-5.2 4.2s-3.6-1.2-5.2-4.2c-1.6-2.8-2.6-6.8-2.6-11.3s1-8.5 2.6-11.3c1.6-2.9 3.6-4.2 5.2-4.2s3.6 1.2 5.2 4.2c1.6 2.8 2.6 6.8 2.6 11.3z"
      />
      <path
        className="raw_material1_svg__st0"
        d="M25.9 27.7c-4.6 2.2-9.2 3.5-12.9 3.8-3.8.3-6-.5-6.9-1.7-.8-1.2-.5-3.2 1.6-5.9 2.1-2.6 5.7-5.3 10.3-7.6s9.2-3.5 12.9-3.8c3.8-.3 6 .5 6.9 1.7.8 1.2.5 3.2-1.6 5.9-2.1 2.6-5.7 5.4-10.3 7.6z"
      />
      <path
        className="raw_material1_svg__st0"
        d="M18.1 27.7c-4.6-2.2-8.2-5-10.3-7.6-2.2-2.7-2.5-4.7-1.6-5.9.8-1.2 3.1-2 6.9-1.7 3.7.3 8.3 1.5 12.9 3.8s8.2 5 10.3 7.6c2.2 2.7 2.5 4.7 1.6 5.9-.8 1.2-3.1 2-6.9 1.7-3.7-.3-8.3-1.5-12.9-3.8z"
      />
    </g>
  </svg>
)
